import {DateTimeFormatter} from "@js-joda/core";

export const DEFAULT_DATE_PATTERN = "yyyy-MM-dd HH:mm";
export const DEFAULT_DATE_TIME_PATTERN = "yyyy-MM-dd HH:mm:ss";
export const DEFAULT_DATE_FORMAT = "yy-mm-dd"

export const DEFAULT_DATE_FORMATTER = DateTimeFormatter.ofPattern(DEFAULT_DATE_PATTERN);
export const DEFAULT_DATE_TIME_FORMATTER = DateTimeFormatter.ofPattern(DEFAULT_DATE_TIME_PATTERN);

export const taskExecutorQueues = [
    {
        value: "DEFAULT",
        label: "Default"
    },
    {
        value: "FAST_COMPUTE",
        label: "Fast Compute"
    },
]

export const DEFAULT_DASHBOARD_URL = "/EASAS/views/dataservices/dataservicedashboard.xhtml?"

export const EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
export const CSV_TYPE = "text/csv;charset=utf-8,";

export const BAR_CHART_DATA_POINTS_LIMIT = 100;

export const EASAS_JS_SCRAPER_URL = () => {
    return process.env.EASASJS_VERSIONS_SCRAPER_URL!!;
};

export const EASAS_REST_URL = () => {
    return `${window.contextRoot}/rest`;
};